import React from 'react'
import {Link} from 'react-router-dom';

const Navbar = () => {
    let current = "Home";
    setTimeout(()=>{
        document.getElementById(current).style.background="#fff";
        document.getElementById(current).style.color="#333";
    },10);
    const changeCurrent = (e)=>{
        const id = e.target.id;
        document.getElementById(id).style.background="#fff";
        document.getElementById(id).style.color="#333";
        document.getElementById(current).style.background="none";
        document.getElementById(current).style.color="#fff";
        current=id;
    }
    return (
        <div id="main-navbar">
            <div className="logo">
                <i className="fas fa-dice-d20 fa-2x"></i>
                <h1 className="Primary">SJ Games</h1>
            </div>
            <div className="nav-tools">
                <Link to='/' onClick={changeCurrent}>
                    <h1 className="secondary" id="Home">Home</h1>
                </Link>
                <Link to='/About' onClick={changeCurrent}>
                    <h1 className="secondary" id="About">About</h1>
                </Link>
            </div>
        </div>
    )
}

export default Navbar
